/**
 * x-filter-reach on a control of the Insights filter bar that carries data-filter-reach="<control>"
 * (components/site-analytics/filter-bar.blade.php): while the control is hovered or holds focus (its
 * popover open, a field being typed in, a pick reloading the cards), the cards it changes are
 * outlined.
 *
 * Which cards those are is the server's (Analytics::filterReach(), each card's data-reached-by), and
 * the outline is resources/css/misc.css's, keyed off REACH_ATTRIBUTE on the document element: outside
 * every Livewire component, so a render while the reader is on the control never wipes it, and read
 * by CSS alone, so the cards need no script of their own. With focus in one control and the pointer
 * on another, the one the reader came to last is shown, and leaving it shows the other again.
 *
 * Nothing is announced: the outline points at what each card's ⓘ panel already lists, and a screen
 * reader hears a filter's effect from the cards themselves.
 */
export const REACH_ATTRIBUTE = 'data-site-analytics-reach';

/** The controls in use, the latest last. */
const active = [];

function show() {
    const current = active.at(-1);

    if (current) {
        document.documentElement.setAttribute(REACH_ATTRIBUTE, current.control);
    } else {
        document.documentElement.removeAttribute(REACH_ATTRIBUTE);
    }
}

export default function FilterReachDirective(el, _directive, { cleanup }) {
    const entry = { control: el.dataset.filterReach ?? '' };
    let hovered = false;
    let focused = false;

    const sync = () => {
        const at = active.indexOf(entry);

        if (at !== -1) active.splice(at, 1);
        if (entry.control !== '' && (hovered || focused)) active.push(entry);

        show();
    };

    const listeners = {
        mouseenter: () => { hovered = true; sync(); },
        mouseleave: () => { hovered = false; sync(); },
        focusin: () => { focused = true; sync(); },
        focusout: (event) => { focused = el.contains(event.relatedTarget); sync(); },
    };

    Object.entries(listeners).forEach(([type, listener]) => el.addEventListener(type, listener));

    cleanup(() => {
        Object.entries(listeners).forEach(([type, listener]) => el.removeEventListener(type, listener));
        hovered = false;
        focused = false;
        sync();
    });
}
